<template>
  <div class="pagina ativa" id="paginaTabela">
    <div class="pagina-titulo" style="display:flex;align-items:center;gap:9px;"><Table2 :size="20" /> Tabela de Comissao</div>
    <div v-if="ehAdmin" style="margin-bottom:15px;">
      <button @click="abrirModalNovo">+ Nova Linha</button>
    </div>
    <div style="overflow-x:auto;">
      <table style="width:100%;border-collapse:collapse;font-size:13px;background:white;border-radius:10px;overflow:hidden;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
        <thead>
          <tr style="background:#4a5c2f;color:white;">
            <th style="padding:10px;text-align:left;">BEM</th>
            <th style="padding:10px;text-align:left;">TABELA</th>
            <th style="padding:10px;text-align:left;">COMISSAO</th>
            <th style="padding:10px;text-align:left;">FORMA PGTO</th>
            <th style="padding:10px;text-align:left;">ESTORNO</th>
            <th style="padding:10px;text-align:left;">PRAZO</th>
            <th style="padding:10px;text-align:left;">TAXA ADM</th>
            <th style="padding:10px;text-align:left;">ANTECIPACAO</th>
            <th style="padding:10px;text-align:left;">FUNDO RES.</th>
            <th v-if="ehAdmin" style="padding:10px;text-align:left;">ACOES</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="carregando"><td colspan="10" style="padding:20px;text-align:center;color:#888;">Carregando...</td></tr>
          <tr v-for="t in tabela" :key="t.linha" :style="{ opacity: (t.status || '').toLowerCase().trim() === 'inativo' ? 0.55 : 1 }">
            <td style="padding:8px 10px;border-bottom:1px solid #eee;">{{ t.bem }}</td>
            <td style="padding:8px 10px;border-bottom:1px solid #eee;">{{ t.tabela }}</td>
            <td style="padding:8px 10px;border-bottom:1px solid #eee;">{{ t.comissao }}</td>
            <td style="padding:8px 10px;border-bottom:1px solid #eee;">{{ t.formaPagamento }}</td>
            <td style="padding:8px 10px;border-bottom:1px solid #eee;">{{ t.estorno }}</td>
            <td style="padding:8px 10px;border-bottom:1px solid #eee;">{{ t.prazo }}</td>
            <td style="padding:8px 10px;border-bottom:1px solid #eee;">{{ t.taxaAdministrativa }}</td>
            <td style="padding:8px 10px;border-bottom:1px solid #eee;">{{ t.antecipacao }}</td>
            <td style="padding:8px 10px;border-bottom:1px solid #eee;">{{ t.fundoReserva }}</td>
            <td v-if="ehAdmin" style="padding:8px 10px;border-bottom:1px solid #eee;white-space:nowrap;">
              <button @click="abrirModalEditar(t)" style="display:inline-flex;align-items:center;justify-content:center;padding:4px 8px;margin-right:5px;margin-top:0;"><Pencil :size="13" /></button>
              <button @click="toggleStatus(t)" :style="{ padding: '4px 8px', fontSize: '12px', marginTop: '0', background: (t.status || '').toLowerCase().trim() === 'inativo' ? '#27ae60' : '#e67e22' }">
                {{ (t.status || '').toLowerCase().trim() === 'inativo' ? '▶ Ativar' : '■■ Inativar' }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="modalAberto" class="app-drawer-overlay">
      <div class="app-drawer">
        <h3>{{ editandoId ? 'Editar' : 'Nova Linha' }}</h3>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:15px;">
          <div><label>BEM</label>
            <select v-model="campo.bem">
              <option>AUTOMOVEL</option><option>SERVICO E MOTO</option><option>PESADOS</option><option>IMOVEIS</option><option>IMOVEL ESTENDIDO</option>
            </select>
          </div>
          <div><label>TABELA</label><input type="text" v-model="campo.tabela" /></div>
          <div><label>COMISSAO</label><input type="text" v-model="campo.comissao" /></div>
          <div><label>FORMA DE PAGAMENTO</label><input type="text" v-model="campo.formaPagamento" /></div>
          <div><label>ESTORNO</label><input type="text" v-model="campo.estorno" /></div>
          <div><label>PRAZO</label><input type="text" v-model="campo.prazo" /></div>
          <div><label>TAXA ADMINISTRATIVA</label><input type="text" v-model="campo.taxaAdministrativa" /></div>
          <div><label>ANTECIPACAO</label><input type="text" v-model="campo.antecipacao" /></div>
          <div><label>FUNDO DE RESERVA</label><input type="text" v-model="campo.fundoReserva" /></div>
        </div>
        <div class="app-drawer-acoes">
          <button @click="fecharModal" style="background:#888;">Cancelar</button>
          <button @click="salvarModal">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPost, getSession } from '../api'
import { Table2, Pencil } from 'lucide-vue-next'

export default {
  components: { Table2, Pencil },
  name: 'PaginaTabelaComissao',
  data() {
    return {
      tabela: [],
      carregando: true,
      modalAberto: false,
      editandoId: null,
      campo: { bem: 'AUTOMOVEL', tabela: '', comissao: '', formaPagamento: '', estorno: '', prazo: '', taxaAdministrativa: '', antecipacao: '', fundoReserva: '' }
    }
  },
  computed: {
    ehAdmin() { return getSession().perfil === 'admin' }
  },
  created() {
    this.carregar()
  },
  methods: {
    async carregar() {
      this.carregando = true
      const r = await apiGet('tabela-comissao/listar')
      if (r.sucesso) this.tabela = r.tabela
      this.carregando = false
    },
    abrirModalNovo() {
      this.editandoId = null
      this.campo = { bem: 'AUTOMOVEL', tabela: '', comissao: '', formaPagamento: '', estorno: '', prazo: '', taxaAdministrativa: '', antecipacao: '', fundoReserva: '' }
      this.modalAberto = true
    },
    abrirModalEditar(t) {
      this.editandoId = t.linha
      this.campo = {
        bem: t.bem, tabela: t.tabela, comissao: t.comissao, formaPagamento: t.formaPagamento,
        estorno: t.estorno, prazo: t.prazo || '', taxaAdministrativa: t.taxaAdministrativa || '',
        antecipacao: t.antecipacao || '', fundoReserva: t.fundoReserva || ''
      }
      this.modalAberto = true
    },
    fecharModal() {
      this.modalAberto = false
    },
    async salvarModal() {
      const payload = { ...this.campo }
      if (this.editandoId) payload.id = this.editandoId
      const r = await apiPost('tabela-comissao/salvar', payload)
      if (r.sucesso) {
        this.fecharModal()
        this.carregar()
      } else {
        alert(r.mensagem || r.erro || 'Erro ao salvar.')
      }
    },
    async toggleStatus(t) {
      const inativo = (t.status || '').toLowerCase().trim() === 'inativo'
      const r = await apiPost('tabela-comissao/status', { id: t.linha, status: inativo ? 'ativo' : 'inativo' })
      if (r.sucesso) this.carregar()
      else alert(r.mensagem || r.erro || 'Erro ao alterar status.')
    }
  }
}
</script>
